import { useEffect, useRef, useState } from "react";

export function ScratchCard({ prize, code, onRevealed }) {
  const canvasRef = useRef(null);
  const revealedRef = useRef(false);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#FF5A00";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#0A0A0A";
    ctx.font = "bold 18px Outfit, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("SCRATCH HERE", canvas.width / 2, canvas.height / 2 - 6);
    ctx.font = "12px Manrope, sans-serif";
    ctx.fillText("swipe to reveal your prize", canvas.width / 2, canvas.height / 2 + 16);
  }, []);

  const checkReveal = () => {
    if (revealedRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let cleared = 0;
    for (let i = 3; i < data.length; i += 40) {
      if (data[i] === 0) cleared++;
    }
    if (cleared / (data.length / 40) > 0.45) {
      revealedRef.current = true;
      setRevealed(true);
      onRevealed?.();
    }
  };

  const scratch = (e) => {
    if (revealedRef.current) return;
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const x = ((clientX - rect.left) / rect.width) * canvas.width;
    const y = ((clientY - rect.top) / rect.height) * canvas.height;
    const ctx = canvas.getContext("2d");
    ctx.globalCompositeOperation = "destination-out";
    ctx.beginPath();
    ctx.arc(x, y, 22, 0, Math.PI * 2);
    ctx.fill();
    checkReveal();
  };

  return (
    <div className="relative w-full max-w-[260px] h-[130px] rounded-lg overflow-hidden border border-[#FF5A00]/50 select-none" data-testid="scratch-card">
      <div className="absolute inset-0 bg-white flex flex-col items-center justify-center text-center px-3">
        <p className="text-xs uppercase tracking-widest text-[#FF5A00] font-bold">You Won</p>
        <p className="text-sm font-extrabold mt-1 leading-tight text-[#0A0A0A]">{prize}</p>
        <p className="font-mono text-base font-bold text-[#FF5A00] mt-1">{code}</p>
      </div>
      {!revealed && (
        <canvas
          ref={canvasRef}
          width={260}
          height={130}
          className="absolute inset-0 w-full h-full touch-none cursor-pointer"
          onMouseMove={(e) => e.buttons === 1 && scratch(e)}
          onMouseDown={scratch}
          onTouchMove={scratch}
          onTouchStart={scratch}
        />
      )}
    </div>
  );
}
